<script setup>

import { onMounted } from 'vue'

import Loading from '@/components/Generics/Loadings/Loading.vue'
import TranslationProvider from '@/provider/translations.js'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faUserCheck } from '@fortawesome/free-solid-svg-icons'

library.add(faCheck, faUserCheck)

const props = defineProps({
  show: Boolean,
  loading: Boolean,
  userList: Array,
  title: String,
  sel_delegated: Array,
  nome_selezionato: String
})

const selezionaDelegato = defineModel('selezionaDelegato')
const selezionato = defineModel('selezionato')

onMounted(async () => {
  selezionato.value = props.sel_delegated[0] ?? ''
})
</script>

<template>
  <Transition name="modal">
    <div class="modal fade d-block modal-mask" tabindex="-1"
         :class="{ 'show': show }"
         v-if="show"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ TranslationProvider.getTrans('app.seleziona_delegati') }}
            </h5>
            <button type="button"
                    class="btn-close border-0 bg-white"
                    data-bs-dismiss="modal"
                    aria-label="Chiudi"
                    @click="$emit('close')"
            ></button>
          </div>
          <div class="modal-body">

            <div class="mb-3">
              <label for="selezionaDelegati" class="form-label">
                {{ title }}
              </label>
              <input id="selezionaDelegati"
                     autocomplete="off"
                     type="text"
                     class="form-control"
                     :placeholder="TranslationProvider.getTrans('app.ricerca_delegati')"
                     v-model="selezionaDelegato"
                     @input="$emit('search', selezionaDelegato)">
              <small class="form-text">
                {{ TranslationProvider.getTrans(
                    'app.select2_min_chars_delegated',
                    'Inserisci almeno 3 caratteri per iniziare la ricerca. Se l\'utente desiderato non compare, contatta l\'amministratore della piattaforma.'
                ) }}
              </small>
            </div>

            <div class="col-12 py-3 border-top mb-3 d-flex align-items-center">
              <p class="m-0" v-if="props.sel_delegated[0]">
                <font-awesome-icon v-if="nome_selezionato" icon="fa-user-check" class="text-primary" />
                <span class="px-2" v-if="nome_selezionato">{{ nome_selezionato }}</span>
              </p>
              <p class="m-0" v-else>
                {{ TranslationProvider.getTrans('app.nessun_delegato_selezionato') }}
              </p>
            </div>

            <loading v-if="loading" class="text-primary"></loading>

            <div v-if="userList && selezionaDelegato && selezionaDelegato.length >=3 && !loading">
              <div v-if="userList.length > 0">
                <table class="table table-striped user-list-table">
                  <thead class="border-bottom">
                  <tr>
                    <th>{{ TranslationProvider.getTrans('app.nome') }}</th>
                    <th>{{ TranslationProvider.getTrans('app.cognome') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="user in userList" :key="user.reference">
                    <td>{{ user.personRelations[0]?.person.firstName ?? user.username }}</td>
                    <td>{{ user.personRelations[0]?.person.lastName ?? '' }}</td>
                    <td class="d-flex justify-content-end">
                      <input type="radio"
                             class="btn-check d-none"
                             name="options"
                             autocomplete="off"
                             v-model="selezionato"
                             :id="'radio-' + user.reference"
                             :value="user.reference"
                             :checked="user.reference === props.sel_delegated[0]"
                      >
                      <label
                        class="label-select-delegato btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                        :for="'radio-' + user.reference"
                        :class="{'btn-primary text-white': props.sel_delegated[0] === user.reference}"
                        @click="$emit('selected', user.reference, selezionato)">
                        <font-awesome-icon icon="fa-check" />
                      </label>
                    </td>
                  </tr>

                  </tbody>
                </table>

              </div>
              <div v-else-if="userList.length === 0">
                <p>
                  {{ TranslationProvider.getTrans('app.nessun_utente_trovato') }}
                </p>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary btn-sm"
                    @click="$emit('close')">
              {{ TranslationProvider.getTrans('app.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.user-list-table tr {
  vertical-align: middle;
}

.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.fa-user-check {
  width: 20px;
}

.label-select-delegato {
  width: 30px;
}
</style>
